<template>
  <div id="exam">
  <b-tabs
    vertical
    nav-wrapper-class="nav-vertical"
  >
    <b-tab title-item-class="wod-tab" active>
      <template #title>
        <feather-icon class="align-middle" icon="ClipboardIcon" />
        <span class="align-middle pl-2 pr-3">Dane egzaminu</span>
      </template>
      <vx-card>
        <exam-details/>
      </vx-card>
    </b-tab>
    <b-tab title-item-class="wod-tab" lazy>
      <template #title>
        <feather-icon class="align-middle" icon="CheckSquareIcon" />
        <span class="align-middle pl-2 pr-3">Pytania</span>
      </template>
      <vx-card>
        <exam-questions/>
      </vx-card>
    </b-tab>
  </b-tabs>
  </div>
</template>

<script>
import axios from "axios"
import notification from "@/notification"
import ExamDetails from "@/views/administration/exams/ExamDetails"
import ExamQuestions from "@/views/administration/exams/ExamQuestions"

export default {
  name: "Exam",
  components: {
    ExamDetails,
    ExamQuestions,
  },
}
</script>
<style lang="scss">
.nav-tabs {
  border: none;
  .wod-tab .nav-link{
    position: relative;
    background: none !important;
    border: none;
    &:not(.active) {
      color: $grey;
      &:after {
        content: '';
        width: 0;
        height: 100%;
        border: 1px solid $grey;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    &.active {
      color: $secondary;
      &:after {
        content: '';
        width: 0;
        height: 100%;
        border: 1px solid $secondary;
        position: absolute;
        box-shadow: 0px 0px 2px $secondary;
        top: 0;
        right: 0;
      }
    }
  }
}
</style>
